import { localDatabaseUrls } from "../backend/constants";
import { postAPI } from "../backend/commons";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import AlertManager from "../shared/Alert/Alert";

export const uploadLandedCostCalculationFile = async ({ file }) => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return null;
  }

  if (!file) {
    AlertManager.error("Choose a spreadsheet to upload.", { contactSupport: false });
    return null;
  }

  const formData = new FormData();
  formData.append("file", file);
  if (tokenInfo?.username) {
    formData.append("uploadedUser", tokenInfo.username);
  }

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.landedCostCalculationUpload}`;

  try {
    const response = await postAPI(apiUrl, formData, tokenInfo);
    if (!response) {
      AlertManager.error("Unable to upload landed cost calculation file.", {
        contactSupport: false,
      });
      return null;
    }

    if (response.ok) {
      return response;
    }

    const errorData = await response.json().catch(() => ({}));
    AlertManager.error(
      errorData?.message || "Unable to upload landed cost calculation file.",
      { contactSupport: false }
    );
    return response;
  } catch (error) {
    AlertManager.error("Unable to upload landed cost calculation file.", {
      contactSupport: false,
    });
    return null;
  }
};

export default uploadLandedCostCalculationFile;
